import { Brand } from './brands';
import { Site } from './sites';

export const SitesToBrands: Record<Site, Brand | undefined> = {
  [Site.A523]: Brand.SNAPCHAT,
  [Site.AR]: Brand.SNAPCHAT,
  [Site.CAREERS]: Brand.SNAPCHAT,
  [Site.CITIZEN]: Brand.SNAP,
  [Site.CREATORS]: Brand.SNAPCHAT,
  [Site.DIVERSITY]: Brand.SNAP,
  [Site.EDUCATORS]: Brand.SNAPCHAT,
  [Site.ENG_BLOG]: Brand.SNAP,
  [Site.EXPERIENCE]: Brand.SNAPCHAT,
  [Site.FOR_BUSINESS]: Brand.SNAPCHAT,
  [Site.NEWSROOM]: Brand.SNAP,
  [Site.PARENTS]: Brand.SNAPCHAT,
  [Site.SANDBOX]: Brand.SNAPCHAT,
  [Site.TRUST]: Brand.SNAPCHAT,
  [Site.SNAP]: Brand.SNAP,
  // These are set to snapchat because they are not yet branded with their own thing
  // Spectacles brand enum exists, but it is not really used anywhere for anything, so safer
  // to leave it as snapchat for now.
  [Site.AVALON]: Brand.SNAPCHAT,
  [Site.ARCADIA]: Brand.SNAPCHAT,
  [Site.CHEERIOS]: Brand.SNAPCHAT,
  [Site.STINSON]: Brand.SNAPCHAT,
};
